import { AD, EP, GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import { useContext } from "react";
import DatePicker from "react-datepicker";
import CircularSpinner from "mmbclient/Components/CircularSpinner";
import { getCookie, formatDate, convertToTwoDecimelNumber } from "mmbclient/Common/CommonFunctions";
import { RenderPagination } from "mmbclient/Components/RenderPagination";
import InvoiceDetailController from "mmbclient/Reports/InvoiceDetailController";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export const InvoiceDetail = () => {

    const store = useContext(GLOBAL_CONTEXT);

    const { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel } = InvoiceDetailController(store);

    return (
        <>
            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                {/* Body Content */}
                <div className="container mt-4">
                    <div className="text-center">
                        <h1>Invoice Detail</h1>
                    </div>
                    <hr class="my-4" />
                    <div className="row mb-4">
                        {
                            (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                <>
                                    <div className="col-md-3">
                                        <label className="form-label">Client</label>
                                        <select
                                            className="form-select"
                                            value={client}
                                            onChange={(e) => setClient(e.target.value)}
                                        >
                                            {clientOption.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </> : null
                        }
                        <div className="col-md-2">
                            <label className="form-label">From Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">To Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-md-1 d-flex align-items-end">
                            <button className="btn btn-primary mt-2" onClick={
                                () => {
                                    setCurrentPage(1); // Reset to first page on search
                                    handleSearch();
                                }
                            }>
                                Search
                            </button>
                        </div>
                    </div>

                    {/* Export Buttons */}
                    <hr class="my-4" />
                    <div className="mb-3 d-flex align-items-center">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control me-2 flex-grow-1"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset to first page on search
                            }}
                        />
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Export
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <button className="dropdown-item" onClick={exportToCSV}>
                                        Export to CSV
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item" onClick={exportToExcel}>
                                        Export to Excel
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Data Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>SNo</th>
                                    {
                                        (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                            <th>Client</th>
                                        </> : null
                                    }
                                    <th>Invoice No.</th>
                                    <th>Invoice Date</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>GSTIN No.</th>
                                    <th>City</th>
                                    <th>Freight Amt</th>
                                    <th>Other</th>
                                    <th>Taxable Amt</th>
                                    <th>CGST</th>
                                    <th>SGST</th>
                                    <th>IGST</th>
                                    <th>Grand Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                            {
                                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                                    <td>{item.client_name}</td>
                                                </> : null
                                            }
                                            <td>
                                                {'invoice_path' in item ? (
                                                    item.invoice_path !== '' ? (
                                                        <>
                                                            <Link
                                                                href="#"
                                                                className="text-primary"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    const url = `${window.location.protocol}//${window.location.hostname}${item.invoice_path}`; // Replace with your URL
                                                                    const options = 'width=800,height=600';
                                                                    window.open(url, '_blank', options);
                                                                }}
                                                            >
                                                                {item.invoice_no} {/* Link text */}
                                                            </Link>
                                                        </>
                                                    ) : (
                                                        item.invoice_no
                                                    )
                                                ) : (
                                                    item.invoice_no
                                                )}
                                            </td>

                                            <td>{formatDate(item.invoice_date)}</td>
                                            <td>{formatDate(item.from_date)}</td>
                                            <td>{formatDate(item.to_date)}</td>
                                            <td>{item.gstin_no}</td>
                                            <td>{item.city_name}</td>
                                            <td>{convertToTwoDecimelNumber(item.basic_amount)}</td>
                                            <td>{convertToTwoDecimelNumber(item.other)}</td>
                                            <td>{convertToTwoDecimelNumber(item.taxable_amount)}</td>
                                            <td>{convertToTwoDecimelNumber(item.tax_amount1)}</td>
                                            <td>{convertToTwoDecimelNumber(item.tax_amount2)}</td>
                                            <td>{convertToTwoDecimelNumber(item.tax_amount3)}</td>
                                            <td>{convertToTwoDecimelNumber(item.grand_total)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="15" className="text-center">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <RenderPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
                            </ul>
                        </nav>
                    </div>
                </div>

                {/* Footer */}
                {/* <footer className="bg-light text-center py-3">
                <div className="container">
                    <span>© 2024 My Application. All Rights Reserved.</span>
                </div>
                </footer> */}
            </div >
        </>
    );

}